import axios from "axios";
import { Filter } from "../types/data";
import { WatchType } from "../utilities/enum/watchtype";
import { Type } from "./movies-requests";

const baseUrlPlatform = "https://api.whatwatch.tv/";

export const sendAnonymData = async (filter: Filter, type: Type) => {
  const bodyAnononymSearchData = {
    genres: filter.genres,
    platforms: filter.providers
      ? filter.providers.map((p) => {
          return {
            id: p.provider_id,
            name: p.provider_name,
            logo: p.logo_path,
          };
        })
      : [],
    years: [filter.startDate.toString(), filter.endDate.toString()],
    isRegistered: false,
    type: type,
  };
  await axios.post(
    `${baseUrlPlatform}stats/anonym_search_data`,
    bodyAnononymSearchData
  );
};
